import React from 'react';
import { RankRow } from '../../../entities/rank-row';
import type { RankTier } from '../../../entities/rank-row';
import type { RankEntry } from '../../../shared/config/menuResultData';
import { List } from './ResultRankingList.styles';

export interface ResultRankingListProps {
  items: RankEntry[];
  visibleRanks?: ReadonlySet<number>;
  startRank?: number;
  className?: string;
}

function tierForRank(rank: number): RankTier {
  if (rank === 2) return 'second';
  if (rank === 3) return 'third';
  return 'fourth';
}

/** 2·3·4위 랭킹 리스트 — foreground 레이어에 배치 (dim 위, 카드 아래) */
export function ResultRankingList({
  items,
  visibleRanks,
  startRank = 2,
  className,
}: ResultRankingListProps) {
  const sorted = [...items].sort((a, b) => b.voteCount - a.voteCount);
  const ranksVisible = visibleRanks ?? new Set(sorted.map((_, i) => startRank + i));

  return (
    <List className={className} aria-label="메뉴 투표 순위 목록">
      {sorted.map((item, i) => {
        const rank = startRank + i;
        if (!ranksVisible.has(rank)) {
          return null;
        }

        return (
          <RankRow
            key={item.id}
            rank={rank}
            name={item.name}
            ratePercent={item.ratePercent}
            voteCount={item.voteCount}
            thumb={item.thumb}
            icon={item.icon}
            tier={tierForRank(rank)}
          />
        );
      })}
    </List>
  );
}
